import {
    GET_PAY_OUT_STATUS_DEF,
    GET_PAY_OUT_STATUS_DEF_SUCCESS,
    PAY_OUT_STATUS_DEF_API_ERROR
} from "./actionTypes"

export const getPayOutStatusDefList = () => ({
    type: GET_PAY_OUT_STATUS_DEF,
})

export const getPayOutStatusDefListSuccess = record => ({
    type: GET_PAY_OUT_STATUS_DEF_SUCCESS,
    payload: record,
})

export const payOutStatusDefApiError = error => {
    return {
        type: PAY_OUT_STATUS_DEF_API_ERROR,
        payload: error,
    }
}
